export default __webpack_public_path__ + "static/insideelevator-e6fce88a1162771aff2a9d7931605f98.gif";